module.exports = __webpack_public_path__ + "img/TransporNet.3c0bb5ec.jpg";